/** @jsxImportSource @emotion/react */
import { NoteEntity } from 'components/lab/billingNotes/BillingNotes'
import { BillingNotesModal } from 'components/lab/billingNotes/BillingNotesModal'
import React from 'react'
import { useGetBillingNotesQuery } from 'store/services/billingNotes'
import { NeedsWorkItemDto } from 'store/types'

// An item's notes are its follow-up log: who called, what they were told.
export const NeedsWorkNotesModal: React.FC<{ item: NeedsWorkItemDto; onClose: () => void }> = ({ item, onClose }) => {
  const target = { type: NoteEntity.NEEDS_WORK, entityId: item.id }
  const { data: notes, refetch } = useGetBillingNotesQuery(target)

  return (
    <BillingNotesModal
      target={{ ...target, title: `Needs Work notes — ${item.reasonLabel}` }}
      notes={notes ?? []}
      onClose={onClose}
      onChange={refetch}
    />
  )
}
